import { defineComponent as _defineComponent } from 'vue'
import BCXSearchSelect from '@/components/molecules/BCXSearchSelect.vue';
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import {
  computed, nextTick, onMounted, ref, toRefs, watch
} from 'vue';
import useUser from '@/mixins/useUser';
import BCXDatepickerField from '@/components/molecules/forms/datepicker/BCXDatepickerField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conditions',
  props: {
  locationValue: {
    type: String,
    default: 'REMOTE_ONLY',
  },
  remoteWorkValue: {
    type: String,
    default: 'TWO_DAYS_PER_WEEK',
  },
  teamSizeValue: {
    type: Number,
    default: 1,
  },
  startDateValue: {
    type: String,
    default: (new Date()).toISOString().split('T')[0],
  },
  durationAmountValue: {
    type: Number,
    default: 3,
  },
  durationUnitValue: {
    type: String,
    default: 'MONTH',
  },
  hoursPerWeekValue: {
    type: Number,
    default: 40,
  },
  dependingOnComplexityValue: {
    type: Boolean,
    default: false,
  },
  isCreatingProject: {
    type: Boolean,
    default: false,
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const {
  locationValue, remoteWorkValue, teamSizeValue,
  startDateValue, durationAmountValue, durationUnitValue,
  hoursPerWeekValue, dependingOnComplexityValue, isCreatingProject
} = toRefs(props);

const { tUserFallback: tUser } = useUser('self');

const getDropdownItems = (translationKey: string): Array<any> => {
  const translation = { ...tUser(`project-forum_USERTYPE.form-section.conditions.${translationKey}.dropdown`) as any };
  const keys = Object.keys(translation);
  return keys.map((key) => ({
    text: translation[key],
    value: key
  }));
};

const location = ref('REMOTE_ONLY');
const locationItems = computed(() => getDropdownItems('location'));

const remoteWork = ref('');
const remoteWorkItems = computed(() => getDropdownItems('remote-work'));

const teamSize = ref(3);

const startDate = ref('');

const durationAmount = ref(3);

const durationUnit = ref('MONTH');
const durationUnitItems = computed(() => getDropdownItems('duration'));

const hours = ref(40);
const dependingOnComplexity = ref(false);
watch(() => dependingOnComplexity.value, (newValue) => {
  if (newValue) {
    hours.value = 0;
  } else {
    hours.value = 40;
  }
});

const pushValue = async () => {
  await nextTick();
  const clientData = {
    location: location.value,
    remoteWork: remoteWork.value,
    teamSize: teamSize.value,
    startDate: startDate.value,
    durationAmount: durationAmount.value,
    durationUnit: durationUnit.value,
    hoursPerWeek: hours.value,
    dependingOnComplexity: dependingOnComplexity.value
  };
  emit('input', clientData);
};

watch(teamSize, (value) => {
  if (value > 999) {
    teamSize.value = 999;
  }
});

watch(durationAmount, (value) => {
  if (value > 9999) {
    durationAmount.value = 9999;
  }
});

watch(hours, (value) => {
  if (value > 60) {
    hours.value = 60;
  }
});

watch([hours, durationUnit, durationAmount, startDate, teamSize, remoteWork, location], () => {
  pushValue();
});

const remoteWorkVisible = computed(() => location.value === 'ONSITE_AND_REMOTE');

onMounted(() => {
  if (locationValue.value) {
    location.value = locationValue.value;
  }
  if (remoteWorkValue.value) {
    remoteWork.value = remoteWorkValue.value;
  }
  if (teamSizeValue.value) {
    teamSize.value = teamSizeValue.value;
  }
  if (startDateValue.value) {
    startDate.value = startDateValue.value;
  }
  if (durationAmountValue.value) {
    durationAmount.value = durationAmountValue.value;
  }
  if (durationUnitValue.value) {
    durationUnit.value = durationUnitValue.value;
  }
  if (hoursPerWeekValue.value) {
    hours.value = hoursPerWeekValue.value;
  }
  if (dependingOnComplexityValue.value) {
    dependingOnComplexity.value = dependingOnComplexityValue.value;
  }
});


return { __sfc: true,props, emit, locationValue, remoteWorkValue, teamSizeValue, startDateValue, durationAmountValue, durationUnitValue, hoursPerWeekValue, dependingOnComplexityValue, isCreatingProject, tUser, getDropdownItems, location, locationItems, remoteWork, remoteWorkItems, teamSize, startDate, durationAmount, durationUnit, durationUnitItems, hours, dependingOnComplexity, pushValue, remoteWorkVisible, BCXSearchSelect, BCXCheckbox, BCXDatepickerField }
}

})